<template>
    <div class="p-10">
        <div ref="lateTransporter" style="height: 400px"></div>
    </div>

</template>

<script>
    import qs from 'qs'

    import * as am4core from '@amcharts/amcharts4/core'
    import * as am4charts from '@amcharts/amcharts4/charts'
    import am4themesAnimated from '@amcharts/amcharts4/themes/animated'

    export default {
        data() {
            return {
                data: [],
                chart: null,
            }
        },
        props : ['filter', 'update'],
        mounted() {
            this.createChart();
            this.fetchData();
        },
        watch: {
            'update' () {
                this.fetchData();
            }
        },
        methods: {
            fetchData () {
                this.$http.get(`/api/h1/transporter-count?${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    if (resp.data.data[0] && resp.data.data[0].total > 0) {
                        this.data = [
                            {type:'On Target', value:resp.data.data[0].total - resp.data.data[0].miss_target},
                            {type:'Late', value:resp.data.data[0].miss_target}
                        ]
                    } else {
                        this.data = [
                            {type:'No Data', value:1},
                        ]
                    }
                })
                .then(()=>{
                    this.loadData();
                })
                .catch((err)=>{console.log(err)});
            },
            loadData() {
                let length = this.chart.data.length

                this.chart.addData(this.data, length)
            },
            createChart() {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themesAnimated)
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.lateTransporter, am4charts.PieChart)

                // Add and configure Series
                let pieSeries = this.chart.series.push(new am4charts.PieSeries())
                pieSeries.dataFields.value = 'value'
                pieSeries.dataFields.category = 'type'


                // Put a thick white border around each Slice
                pieSeries.slices.template.stroke = am4core.color('#fff')
                pieSeries.slices.template.strokeWidth = 2
                pieSeries.slices.template.strokeOpacity = 1
                pieSeries.slices.template
                    // change the cursor on hover to make it apparent the object can be interacted with
                    .cursorOverStyle = [
                        {
                            'property': 'cursor',
                            'value': 'pointer'
                        }
                    ]

                // pieSeries.alignLabels = false
                // pieSeries.labels.template.bent = true
                // pieSeries.labels.template.radius = 30
                // pieSeries.labels.template.padding(0, /0, 0, 0)

                // pieSeries.ticks.template.disabled = true

                // Create a base filter effect (as if it's not there) for the hover to return to
                let shadow = pieSeries.slices.template.filters.push(new am4core.DropShadowFilter())
                shadow.opacity = 0

                // Create hover state
                let hoverState = pieSeries.slices.template.states.getKey('hover') // normally we have to create the hover state, in this case it already exists

                // Slightly shift the shadow and make it more prominent on hover
                let hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter())
                hoverShadow.opacity = 0.7
                hoverShadow.blur = 5

                // Add a legend
                this.chart.legend = new am4charts.Legend()
            }
        }
    }
</script>